import React, { useEffect, useState } from "react";
import CoreCalendar from "../../../app/core/components/CoreCalendar/CoreCalendar";
import {
  useGetUserCalendarQuery,
  useGetUserOpenBoxQuery,
} from "../../api/user/calendarApi";
import EventDetail from "./EventDetail";
import LockScreen from "../../../app/core/components/CoreLockScreen/LockScreen";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { formatTimeRange } from "../../../utils/functions/date-utils";

const CalendarPage = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [singleEvent, setSingleEvent] = useState();
  const [deadlines, setDeadlines] = useState([]);

  const { data: dataCalendar } = useGetUserCalendarQuery();
  const { data: dataOpenBox } = useGetUserOpenBoxQuery();

  const navigate = useNavigate();

  const handleOpen = (el) => {
    setSingleEvent(el);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (dataCalendar && dataCalendar.Data) {
      setDeadlines(
        dataCalendar.Data.map((item) => ({
          date: item.date,
          detailsContent: item.detailsContent,
          detailsTitle: item.detailsTitle,
          id: item.id,
        }))
      );
    }
    if (dataOpenBox && dataOpenBox.Data) {
      setDeadlines((prevDeadlines) => [
        ...prevDeadlines,
        ...dataOpenBox.Data.map((item) => ({
          date: `${item.data.slice(0, 4)}-${item.data.slice(
            4,
            6
          )}-${item.data.slice(6, 8)}T00:00:00`,
          detailsContent: item.detailsContent,
          detailsTitle: formatTimeRange(item.ora_Inizio, item.ora_Fine),
          id: item.id,
        })),
      ]);
    }
  }, [dataCalendar, dataOpenBox]);

  return (
    <div>
      <LockScreen
        text={`${t("NotAlreadyAssociated")}`}
        cta={() => navigate(`/auth/user/associa-${t("studio")}`)}
      />
      <h2>{t("Calendar")}</h2>

      <div className="flex lg:space-x-8 flex-col lg:flex-row space-y-8 lg:space-y-0 h-full">
        <div className="w-full lg:w-8/12 h-full">
          <CoreCalendar
            events={deadlines?.map((el) => ({
              id: el.id,
              title: el.detailsTitle,
              date: el.date,
              extendedProps: {
                description: el.detailsContent,
              },
            }))}
            onOpen={handleOpen}
          />
        </div>

        <div className="w-full lg:w-4/12 flex justify-center items-center shadow-md   ">
          {open ? (
            <EventDetail event={singleEvent} onClose={handleClose} />
          ) : (
            <p className="text-gray">nessuna scadenza selezionata</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;
